import React from 'react';
import { CustomStepProps } from '../../types/survey';
import { Button } from '../ui/Button';

/**
 * Simple Body Shape and Weight Introduction Slide
 */
export const BodyWeightIntroSlide: React.FC<CustomStepProps> = ({
  onNext,
  onBack,
  currentStep,
  totalSteps
}) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-royal-blue-lightest via-white to-royal-gold-lightest flex items-center justify-center p-4">
      <div className="max-w-2xl w-full">
        <div className="bg-white rounded-2xl shadow-xl p-12">
          {/* Main Content */}
          <div className="text-center">
            <h1 className="text-5xl font-bold text-gray-900 mb-6">
              Body shape and weight
            </h1>
            <p className="text-xl text-gray-700 leading-relaxed mb-12">
              The correct weight and body shape have an impact on our health, fitness and general well-being. 
              Maintaining a healthy weight is an effective form of prevention, which reduces the risk of 
              lifestyle diseases, such as diabetes and cardiovascular diseases. Answer a few questions that 
              will help our experts understand your experiences and goals related to maintaining a healthy 
              weight and body shape.
            </p>
          </div>

          {/* Progress Indicator */}
          <div className="mb-8">
            <div className="flex justify-between items-center mb-2">
              <span className="text-sm text-gray-600">Progress</span>
              <span className="text-sm font-semibold text-royal-gold">
                Step {currentStep + 1} of {totalSteps}
              </span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2">
              <div 
                className="bg-gradient-to-r from-royal-gold to-royal-blue h-2 rounded-full transition-all duration-300"
                style={{ width: `${((currentStep + 1) / totalSteps) * 100}%` }}
              />
            </div>
          </div>

          {/* Navigation Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              onClick={onBack}
              variant="secondary"
              size="lg"
              className="w-full sm:w-auto"
            >
              Previous
            </Button>
            
            <Button
              onClick={onNext}
              variant="primary"
              size="lg"
              className="w-full sm:w-auto"
            >
              Continue
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};